const state = {
  sidebarOpen: true
}

const getters = {
  getSidebarOpen: (state) => {
    return state.sidebarOpen
  }
}

const actions = {
  toggleSidebar ({ commit }) {
    commit('SET_sidebarOpen')
  },
  closeSidebar ({ commit }) {
    commit('SET_sidebarClose')
  }
}

const mutations = {
  SET_sidebarOpen (state) {
    state.sidebarOpen = !state.sidebarOpen
  },
  SET_sidebarClose (state) {
    state.sidebarOpen = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js